import {z as r} from 'zod';

export const complaintsCountSchema = r.object({
    value: r.number(),
    comparedValue: r.number().nullable(),
    delta: r.number().nullable(),
});

export type ComplaintsCountType = r.infer<typeof complaintsCountSchema>;
